import api from "./api";

export const listTickets = (params = {}) => api.get("/support/tickets", { params });
export const getTicket = (id) => api.get(`/support/tickets/${id}`);
export const createTicket = (data) => api.post("/support/tickets", data);
export const replyTicket = (id, content) => api.post(`/support/tickets/${id}/reply`, { content });
export const closeTicket = (id) => api.patch(`/support/tickets/${id}/close`);
